export default "__VITE_ASSET__BxKWkv0k__"